import React from 'react';
import ProviderPage from './Page.tsx';
import { loadProvider } from '@/common/api';
import { LoaderFunctionArgs } from 'react-router-dom';
import PageFade from '@/common/components/PageFade.tsx';

export async function loader({ params }: LoaderFunctionArgs) {
  if (!params.providerId) {
    throw new Response('Missing provider ID', { status: 400 });
  }

  return loadProvider(params.providerId);
}

const ProviderRoute: React.FC = () => {
  return (
    <PageFade>
      <ProviderPage />
    </PageFade>
  );
};

export default ProviderRoute;
